var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDropdownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{fill:black;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron_Selected",
    "data-name": "Chevron Selected",
    transform: "rotate(-90 5 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M0 0h10v22H0z",
    className: "cls-1",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Chevron",
    d: "M0 7.5L7.75 0l1.536 1.486L3.071 7.5l6.215 6.014L7.75 15z",
    className: "cls-2",
    transform: "translate(3 6.333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDropdownDark);
export default __webpack_public_path__ + "static/media/chevron-dropdown-dark.05e54053ec113e4bba6ac22d3f71d5fa.svg";
export { ForwardRef as ReactComponent };